import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { AccountService } from '../../../services/account.service';
import { CounsellorProfilePrefVM } from '../../../models/CounsellorProfilePrefVM';
import { OrganisationSessionPreferencesVM } from '../../../models/OrganisationSessionPreferencesVM';
import { SessionType } from '../../../models/SessionType';
import { SessionDuration } from '../../../models/SessionDuration';

@Component({
  selector: 'session-options',
  templateUrl: './session-options.component.html'
})
export class SessionOptionsComponent extends BaseComponent implements OnInit {

  //model sent/recieved from api
  model: OrganisationSessionPreferencesVM = new OrganisationSessionPreferencesVM();

  myForm: FormGroup;

  //temp variables to help with checkbox 
  audio: boolean = false;
  video: boolean = false;
  im: boolean = false;
  session25Valid: boolean = false;
  session50Valid: boolean = false;
  session80Valid: boolean = false;

  sessionTypeSelected: boolean = false;
  sessionDurationSelected: boolean = false;

  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService
  ) {
    super(route);
  }

  ngOnInit(): void {

    this.emitDisplayLoadingDialog(true);

    this.accService.getSessionPreferences()
      .subscribe(
        //success
        pref => {
          this.model = pref;

          this.video = (this.model.sessionTypes & SessionType.video) != 0;
          this.audio = (this.model.sessionTypes & SessionType.audio) != 0;
          this.im = (this.model.sessionTypes & SessionType.im) != 0;
          this.session25Valid = (this.model.durations & SessionDuration.duration25Mins) != 0;
          this.session50Valid = (this.model.durations & SessionDuration.duration50Mins) != 0;
          this.session80Valid = (this.model.durations & SessionDuration.duration80Mins) != 0;

          this.validateSessionTypeSelected();
          this.validateDurationCharges();
        },
        //error
        error => {
          console.log(error);
          this.showDialog("Error occured loading data, please refresh page", true);
          this.emitDisplayLoadingDialog(false);
        },
        //complete
        () => {
          this.emitDisplayLoadingDialog(false);
        });

    this.myForm = this.fb.group({
      videosession: new FormControl(null),
      audiosession: new FormControl(null),
      messagingsession: new FormControl(null),
      session25Valid: new FormControl(''),
      session50Valid: new FormControl(''),
      session80Valid: new FormControl('')
    });

  }

  validateSessionTypeSelected(): boolean {
    if (this.video || this.audio || this.im) {
      this.sessionTypeSelected = true;
    }
    else {
      this.sessionTypeSelected = false;
    }

    return this.sessionTypeSelected;
  }

  isSessionChecked(event: any, type: string) {
    switch (type) {
      case 'video':
        this.video = event.currentTarget.checked;
        break;
      case 'audio':
        this.audio = event.currentTarget.checked;
        break;
      case 'im':
        this.im = event.currentTarget.checked;
        break;
    }

    this.validateSessionTypeSelected();
  }

  validateDurationCharges(): boolean {
    if (this.session25Valid || this.session50Valid || this.session80Valid) {
      this.sessionDurationSelected = true;
    }
    else {
      this.sessionDurationSelected = false;
    }

    return this.sessionDurationSelected;
  }

  onSubmit(): void {
    if (this.myForm.valid && this.validateSessionTypeSelected() && this.validateDurationCharges()) {
      this.emitDisplayLoadingDialog(true);

      this.model.sessionTypes = ((this.video ? SessionType.video : 0) | (this.audio ? SessionType.audio : 0) | (this.im ? SessionType.im : 0));
      this.model.durations = ((this.session25Valid ? SessionDuration.duration25Mins : 0) |
        (this.session50Valid ? SessionDuration.duration50Mins : 0) |
        (this.session80Valid ? SessionDuration.duration80Mins : 0));

      this.accService.updateSessionPreferences(this.model)
        .subscribe(r => {
          if (r) {
            this.showDialog("Changes saved successfully", false);
          }
          else {
            this.showDialog("Changes not saved due to an error, please try again", true);
          }
        },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          },
          () => { this.emitDisplayLoadingDialog(false); }
        )
    }
  }

}
